// extracted by mini-css-extract-plugin
module.exports = {"imageTextCell":"ImgText_imageTextCell__K1XMP","imageTextCellImg":"ImgText_imageTextCellImg__yLuFo"};